import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [status, setStatus] = useState("checking");
  const { clear } = useCart();
  const nav = useNavigate();

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { clear(); setStatus("paid"); return; }
        if (data.status === "expired" || tries > 8) { setStatus("error"); return; }
      } catch { if (tries > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="App bg-[#080808] min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        {status === "checking" && (<><Loader2 className="animate-spin mx-auto text-[#C7F000]" size={40} /><p className="mt-6 overline">Confirming payment…</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto text-[#C7F000]" size={56} />
          <h1 className="font-display font-light text-5xl tracking-tighter mt-6">Order confirmed.</h1>
          <p className="text-[#8A8782] text-sm mt-4">Your feeders are being prepped for overnight dispatch. A confirmation is on its way.</p>
          <div className="flex gap-4 justify-center mt-10">
            <button onClick={() => nav("/orders")} className="btn-toxic px-8 py-3" data-testid="view-orders-btn">View Orders</button>
            <button onClick={() => nav("/shop")} className="px-8 py-3 border border-[#222] overline hover:border-[#444] transition-colors">Keep Shopping</button>
          </div>
        </>)}
        {status === "error" && (<>
          <XCircle className="mx-auto text-[#D94026]" size={56} />
          <h1 className="font-display font-light text-4xl tracking-tighter mt-6">Couldn't confirm payment.</h1>
          <p className="text-[#8A8782] text-sm mt-4">If you were charged, contact us. Otherwise try again.</p>
          <button onClick={() => nav("/shop")} className="btn-toxic px-8 py-3 mt-8">Back to Shop</button>
        </>)}
      </div>
    </div>
  );
}
